/**
 * Application Version Configuration
 * Automatically generates version with timestamp for cache busting
 */

// Base version - update this when making major releases
export const BASE_VERSION = '1.2.0';

// Build timestamp for cache busting
export const BUILD_TIMESTAMP = 1757367608833;

// Full version string with build info
export const APP_VERSION = `${BASE_VERSION}.${BUILD_TIMESTAMP}`;

// Short version for display
export const DISPLAY_VERSION = BASE_VERSION;

// Version info object
export const VERSION_INFO = {
  version: BASE_VERSION,
  build: BUILD_TIMESTAMP,
  full: APP_VERSION,
  display: DISPLAY_VERSION,
  buildDate: new Date(BUILD_TIMESTAMP).toISOString(),
  environment: import.meta.env.MODE || 'development'
};

// Cache busting query parameter
export const CACHE_BUSTER = `v=${BUILD_TIMESTAMP}`;

// Helper function to add version to URLs for cache busting
export const addVersionToUrl = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${CACHE_BUSTER}`;
};

// Helper function to get version display text
export const getVersionDisplay = (): string => {
  const env = VERSION_INFO.environment;
  if (env === 'development') {
    return `v${DISPLAY_VERSION}-dev`;
  }
  return `v${DISPLAY_VERSION}`;
};

// Helper function to get full version info for debugging
export const getFullVersionInfo = () => {
  return {
    ...VERSION_INFO,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString()
  };
};
